// extracted by mini-css-extract-plugin
export default {"user-info":"user-info-styles_user-info__AKgly","user-info__avatar":"user-info-styles_user-info__avatar__KaSoK"};